global.userName=("tt");
global.UserId="";